import { render, staticRenderFns } from "./RequiredExplained.vue?vue&type=template&id=142d7fe9"
import script from "./RequiredExplained.vue?vue&type=script&lang=js"
export * from "./RequiredExplained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports